<script>
    import FaEdit from 'svelte-icons/fa/FaEdit.svelte'
    import FaAddressCard from 'svelte-icons/fa/FaAddressCard.svelte'
    import FaLocationArrow from 'svelte-icons/fa/FaLocationArrow.svelte'
    import AddressView from './AddressView.svelte'
    import PriceView from './PriceView.svelte'
    import Banner from './Banner.svelte'
    import FaMarker from 'svelte-icons/fa/FaMarker.svelte'
    import FaPen from 'svelte-icons/fa/FaPen.svelte'
    import FaAlignJustify from 'svelte-icons/fa/FaAlignJustify.svelte'
    import FaPenNib from 'svelte-icons/fa/FaPenNib.svelte'

    export let order
    export let orderIndex
    export let removeFromCart
    export let isError = false
</script>
<style>
    .isError {
        border-color: var(--red);
    }

    h4.label {
        font-weight: bold;
    }

    card p {
        margin: 0;
    }
</style>
<card class='flex-auto mb1' class:isError={isError}>
    <div class="flex flex-column flex-auto mr1">

        <div class="flex ">
            <div class="mb1 flex flex-column  flex-auto">
                <h4 class='mb1 label'><span class="icon small"><FaPenNib/></span>Title</h4>
                {#if order.content.title}
                    <h4 class='nearInkText'>"{order.content.title}"</h4>
                {:else}
                    <h4 class='nearInkText italic'>No title.</h4>
                {/if}
            </div>

            <a href="/new?load={orderIndex}" class='flex-none'>
                <h5 class='flex items-center area'><span class="icon small"><FaPen/></span>Edit</h5>
            </a>
        </div>
        <h4 class='mb1 label'><span class="icon small"><FaAlignJustify/></span>Message</h4>
        {#if order.content.message}
            <h4 class='nearInkText'>"{order.content.message}"</h4>
        {:else}
            <h4 class='nearInkText italic label'>No message.</h4>
        {/if}
    </div>

    <hr>
    <AddressView address={order.fromAddress} icon={FaAddressCard}>From</AddressView>
    <hr>
    <AddressView address={order.toAddress} icon={FaLocationArrow}>To</AddressView>
    <hr>
    <div class="flex py1">
        <h3 class="flex-auto">Price:</h3>
        <PriceView cl='self-end bold' price={order.price} originalPrice={order.originalPrice}/>
    </div>
    {#if order.promoCode}
        <Banner cl='mt1 success'>Successfully applied <b>{order.promoCode}</b></Banner>
    {/if}
    <h5 class='clickable mt1' on:click={()=>removeFromCart(orderIndex)}>Remove from Cart</h5>
</card>